import { schema } from "normalizr";
import { BrandRecord } from "records/brand/brand";

export const Brand = new schema.Entity(
    "brand",
    {},
    {
        idAttribute: "_id",
    }
);

(Brand as any).record = BrandRecord;
